<div class="component-right-view helper-top-padding">
  <h3 class="component-right-view__top-heading">Our latest Blog Posts</h3>
  <div *ngIf="dataBlogPosts" class="grid-flex grid-wrap">
    <app-single-forum-small-view *ngFor="let post of dataBlogPosts | search: searchQuery" [searchQuery]="searchQuery"
                                 [blogPostData]="post"></app-single-forum-small-view>
  </div>
  <p *ngIf="dataBlogPosts.length === 0 || (dataBlogPosts | search:searchQuery).length === 0" class="global-no-results">
    Please <a href="{{loginURL}}" class="helper-color-red"><strong>log in</strong></a> to see blog posts or no search
    results were found.</p>
  <div *ngIf="isPostsNotLoaded">
    <app-loader></app-loader>
  </div>
</div>
